import { render } from "./delete-modal.vue?vue&type=template&id=7a0cd82b"
import script from "./delete-modal.vue?vue&type=script&lang=js"
export * from "./delete-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__